<template>
    <div class="jjxq">
        <div class="jjxqcontent">
            <img src="../../assets/wyjj/wy.png" alt="">
            <div class="zi">
                <span class="style1">{{list.name}}</span>
                <span>成立时间：{{list.time}}</span>
                <span>地址：{{list.addr}}</span>
                <span>负责人：{{list.ren}}</span>
                <span>联系电话：{{list.phone}}</span>
                <span>职责：{{list.zz}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:{
                name:'阳光小区物业',
                ren:'张全',
                time:'2020-02-01',
                zz:'管理员',
                phone:'18879332123',
                addr:'江苏省宜兴市',
                scr:require('../../assets/wyjj/fwry.png'),
            }
        }
    },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>
<style lang="less" scoped>
    .jjxq{
        .jjxqcontent{
            margin: 5%;
            display: flex;
            flex-direction: column;
            img{
                width: 100%;
                height: 200px;
                border-radius: 10px;
            }
            .zi{
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                line-height: 30px;
                .style1{
                    color: #333333;
                    font-size: 20px;
                }
                span{
                    color: #999999;
                    font-size: 15px;
                }
            }
        }
    }
</style>